(function () {
  'use strict';

  function initProductAnchors() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest(
        '.rrts-hero__btn[href="#rrts-products"], .rrts-cta__btn[href="#rrts-products"]'
      );

      if (!button) {
        return;
      }

      var target = document.getElementById('rrts-products');
      if (!target) {
        return;
      }

      event.preventDefault();
      if (window.location.hash !== '#rrts-products') {
        window.history.pushState(null, '', '#rrts-products');
      }
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductAnchors);
  } else {
    initProductAnchors();
  }
})();

(function () {
  'use strict';

  var SPEED          = 0.0022;
  var PAUSE_END_MS   = 1000;
  var PAUSE_RESET_MS = 400;
  var MOBILE_BP      = 1099;

  var DESKTOP_STOPS = [0.15, 0.50, 0.90];

  function RRTSMissions(section) {
    this.section   = section;
    this.track     = section.querySelector('.js-rrts-track');
    this.ball      = section.querySelector('.js-rrts-ball');
    this.missions  = Array.prototype.slice.call(section.querySelectorAll('.js-rrts-mission'));
    this.svgEl     = section.querySelector('.js-rrts-svg');
    this.pathEl    = null;
    this.pathLen   = 0;

    this.progress      = 0;
    this.textsRevealed = false;
    this.running       = false;

    this.mobileH     = 0;
    this.mobileStops = [];

    this._lastMobile = null;

    this._observe();
  }

  RRTSMissions.prototype._isMobile = function () {
    return window.innerWidth <= MOBILE_BP;
  };

  RRTSMissions.prototype._observe = function () {
    var self = this;

    if (!('IntersectionObserver' in window)) {
      self.running = true;
      self._revealAll();
      setTimeout(function () { self._boot(); }, 80);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !self.running) {
        self.running = true;
        setTimeout(function () { self._boot(); }, 80);
        io.disconnect();
      }
    }, { threshold: 0.08 });
    io.observe(this.section);
  };

  RRTSMissions.prototype._boot = function () {
    var mobile = this._isMobile();
    this._lastMobile = mobile;
    if (mobile) {
      this._setupMobile();
    } else {
      this._setupDesktop();
    }
    this.progress = 0;
    this._showBall();
    var self = this;
    requestAnimationFrame(function () { self._tick(); });
  };

  RRTSMissions.prototype._setupDesktop = function () {
    if (this.svgEl) {
      this.svgEl.style.display  = 'block';
      this.svgEl.style.position = 'absolute';
    }
    this.pathEl  = this.svgEl ? this.svgEl.querySelector('.js-rrts-path') : null;
    this.pathLen = this.pathEl ? this.pathEl.getTotalLength() : 0;
  };

  RRTSMissions.prototype._setupMobile = function () {
    if (this.svgEl) { this.svgEl.style.display = 'none'; }

    var trackRect = this.track.getBoundingClientRect();

    this.mobileH = this.track.offsetHeight
      || this.track.scrollHeight
      || this.missions.reduce(function (s, el) { return s + el.offsetHeight; }, 0)
      || 360;

    if (this.mobileH < 120) { this.mobileH = 360; }

    this.mobileStops = this.missions.map(function (el) {
      var r   = el.getBoundingClientRect();
      var top = r.top - trackRect.top;
      return Math.max(0, Math.min(top / this.mobileH, 0.95));
    }, this);
  };

  RRTSMissions.prototype._showBall = function () { this.ball.style.opacity = '1'; };
  RRTSMissions.prototype._hideBall = function () { this.ball.style.opacity = '0'; };

  RRTSMissions.prototype._tick = function () {
    var self = this;
    this.progress += SPEED;

    if (this.progress >= 1) {
      this.progress = 1;
      this._moveBall();
      if (!this.textsRevealed) { this._revealAll(); }

      setTimeout(function () {
        self._hideBall();
        setTimeout(function () {
          self.progress      = 0;
          self.textsRevealed = true;
          self._showBall();
          requestAnimationFrame(function () { self._tick(); });
        }, PAUSE_RESET_MS);
      }, PAUSE_END_MS);
      return;
    }

    this._moveBall();
    if (!this.textsRevealed) { this._revealUpTo(this.progress); }

    requestAnimationFrame(function () { self._tick(); });
  };

  RRTSMissions.prototype._moveBall = function () {
    var mobile = this._isMobile();

    if (mobile !== this._lastMobile) {
      this._lastMobile = mobile;
      if (mobile) {
        this._setupMobile();
      } else {
        this._setupDesktop();
      }
    }

    if (mobile) {
      var y = this.progress * this.mobileH;
      this.ball.style.top  = y + 'px';
      this.ball.style.left = '3px';
    } else {
      if (!this.pathEl) { return; }
      var pt     = this.pathEl.getPointAtLength(this.progress * this.pathLen);
      var coords = this._svgToContainer(pt);
      this.ball.style.left = coords.x + 'px';
      this.ball.style.top  = coords.y + 'px';
    }
  };

  RRTSMissions.prototype._svgToContainer = function (pt) {
    var svgR   = this.svgEl.getBoundingClientRect();
    var trkR   = this.track.getBoundingClientRect();
    var vb     = this.svgEl.viewBox.baseVal;
    var sx     = svgR.width  / vb.width;
    var sy     = svgR.height / vb.height;
    return {
      x: pt.x * sx + (svgR.left - trkR.left),
      y: pt.y * sy + (svgR.top  - trkR.top)
    };
  };

  RRTSMissions.prototype._revealUpTo = function (progress) {
    var stops = this._isMobile() ? this.mobileStops : DESKTOP_STOPS;
    this.missions.forEach(function (el, i) {
      if (progress >= (stops[i] !== undefined ? stops[i] : 0)) {
        el.classList.add('is-visible');
      }
    });
  };

  RRTSMissions.prototype._revealAll = function () {
    this.missions.forEach(function (el) { el.classList.add('is-visible'); });
  };

  function init() {
    document.querySelectorAll('.js-rrts-missions').forEach(function (section) {
      new RRTSMissions(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  'use strict';

  function pauseOtherVideos(activeVideo) {
    document.querySelectorAll('.rrts-tested__video').forEach(function (video) {
      if (video !== activeVideo) {
        video.pause();
      }
    });
  }

  function syncVideoState(video) {
    var frame = video.closest('.rrts-tested__img-frame');

    if (!frame) {
      return;
    }

    if (video.paused || video.ended) {
      frame.classList.remove('is-playing');
    } else {
      frame.classList.add('is-playing');
    }
  }

  function playTestedVideo(video) {
    pauseOtherVideos(video);
    video.play();
  }

  function initTestedVideos() {
    document.addEventListener('click', function (event) {
      var playButton = event.target.closest('.rrts-tested__play');

      if (!playButton) {
        return;
      }

      var frame = playButton.closest('.rrts-tested__img-frame');
      var video = frame ? frame.querySelector('.rrts-tested__video') : null;

      if (!video) {
        return;
      }

      event.preventDefault();
      playTestedVideo(video);
    });

    document.querySelectorAll('.rrts-tested__video').forEach(function (video) {
      video.addEventListener('play', function () {
        pauseOtherVideos(video);
        syncVideoState(video);
      });

      video.addEventListener('pause', function () {
        syncVideoState(video);
      });

      video.addEventListener('ended', function () {
        syncVideoState(video);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestedVideos);
  } else {
    initTestedVideos();
  }
})();

(function () {
  'use strict';

  var lightbox;
  var viewport;
  var image;
  var closeButton;
  var lastTrigger;

  function buildLightbox() {
    lightbox = document.createElement('div');
    lightbox.className = 'rrts-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Collection image preview');
    lightbox.innerHTML = [
      '<div class="rrts-lightbox__dialog" role="document">',
      '  <button type="button" class="rrts-lightbox__close" aria-label="Close image">&times;</button>',
      '  <div class="rrts-lightbox__viewport">',
      '    <img class="rrts-lightbox__image" alt="">',
      '  </div>',
      '</div>'
    ].join('');

    document.body.appendChild(lightbox);
    viewport = lightbox.querySelector('.rrts-lightbox__viewport');
    image = lightbox.querySelector('.rrts-lightbox__image');
    closeButton = lightbox.querySelector('.rrts-lightbox__close');

    closeButton.addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', function (event) {
      if (
        !event.target.closest('.rrts-lightbox__image') &&
        !event.target.closest('.rrts-lightbox__close')
      ) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lightbox.classList.contains('is-open')) {
        closeLightbox();
      }
    });
  }

  function openLightbox(trigger) {
    if (!lightbox) {
      buildLightbox();
    }

    lastTrigger = trigger;
    image.src = trigger.getAttribute('data-rrts-lightbox-src');
    image.alt = trigger.getAttribute('data-rrts-lightbox-alt') || '';
    lightbox.classList.add('is-open');
    document.body.classList.add('rrts-lightbox-open');
    closeButton.focus();
  }

  function closeLightbox() {
    if (!lightbox) {
      return;
    }

    lightbox.classList.remove('is-open');
    document.body.classList.remove('rrts-lightbox-open');
    image.removeAttribute('src');

    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
  }

  function initCollectionLightbox() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-rrts-lightbox-src]');

      if (!trigger) {
        return;
      }

      event.preventDefault();
      openLightbox(trigger);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionLightbox);
  } else {
    initCollectionLightbox();
  }
})();
